<template>
    <div class="main-container">
      <tl-header type="h1">
          <div class="main-header">Please Select Month and Year:</div>
      </tl-header>
      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />    
      <div class="itStatementContainer">
        <!-- <div class="payslipContainer">
          <div class="wrapper">
            <div class="wrapperDiv" v-for="item in dropDown">
              <span>{{(item.month +" "+ item.year)}}</span>
            </div>
          </div>
        </div> -->
        <div class="itStatementHeader">
          <h3>Year/Month</h3>
          <tl-select class="searchDiv" :options="monthOptions" placeholder="Month" v-model="month" @change="(val)=> month = val"/>
          <img src="@/assets/DownloadEss.svg" alt="" @click="downloadEssITSheet()" class="downloadButton">
        </div>
      </div>
    </div>
  </template>

  <script>
  import { mapActions } from 'vuex';
  const crypto = require("crypto");
  export default {
    data() {
      return {
        monthOptions: [],
        month: "",
        newPayslipMonth: null,
        errmsg: "",
        toast: false
      };
    },

    mounted() {
    this.getPayrollMonths();
  },

  activated() {
    this.getPayrollMonths();
  },

  computed: {
    le_id(){
      return localStorage.getItem("le_id")
    },

    empId(){
      return localStorage.getItem("empId")
    },
  },

  methods: {
    ...mapActions({
      act_getPayrollMonthList: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchPayrollMonthList',
      act_downloadpayslip: "dashboard/organisation/utilities/itsheetandpayslip/downloadPayslip",
      itsheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadITSheet",
      act_download_new_itSheet: "dashboard/organisation/utilities/itsheetandpayslip/downloadNewItsheet",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
    }),

    async getPayrollMonths() {
      try {
        let obj ={
          emp_id : this.empId,
          le_id: this.le_id
        }
        let payrollMonths = [];
        let months = [];
        let res = await this.act_getPayrollMonthList(obj);
        if(res.data && res.data.payload){
          res.data.payload.payload.data.length && res.data.payload.payload.data.map(element => {
            months = Object.keys(element.masterSal);
            months.map(item => {
              item = `${item}-${element.FY}`;
              payrollMonths.push(item);
            });
          })
          this.monthOptions = payrollMonths;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error.message;
      }
    },

    getMonthName(month) {
      try {
        switch (month) {
          case "jan":
            this.newPayslipMonth = "January";
            break;
          case "feb":
            this.newPayslipMonth = "February";
            break;
          case "mar":
            this.newPayslipMonth = "March";
            break;
          case "apr":
            this.newPayslipMonth = "April";
            break;
          case "may":
            this.newPayslipMonth = "May";
            break;
          case "jun":
            this.newPayslipMonth = "June";
            break;
          case "jul":
            this.newPayslipMonth = "July";
            break;
          case "aug":
            this.newPayslipMonth = "August";
            break;
          case "sep":
            this.newPayslipMonth = "September";
            break;
          case "oct":
            this.newPayslipMonth = "October";
            break;
          case "nov":
            this.newPayslipMonth = "November";
            break;
          case "dec":
            this.newPayslipMonth = "December";
            break;
          default:
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async downloadEssITSheet() {
      try {
        let month = this.month.split("-")[0]
        this.getMonthName(month);
        let obj ={
          'employee_id': this.empId
        }
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        let itObj = {
          empCode: this.employeeData.code,
          month: this.newPayslipMonth,
          clientName: this.employeeData.first_name,
          reportType: "pdf",
          assesmentYear: this.month.split("-")[1],
          clientCode: this.employeeData.legalEntityDetails.clientCode,
          legalEntityId: this.employeeData.legal_entity_id // PL_3042
        }
        let data = await this.encryptData(itObj);
        let res = await this.act_download_new_itSheet(data);
        let apiResponse = JSON.parse(await this.decrypt(res.data.data));
        const url = apiResponse.pdfPreSignedUrl;            
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "It Sheet.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.toast = true;
        this.errmsg = "salary details from payroll not available for this month!";
      }
    },

    async encryptData(payload) {
      try {
        const iv = crypto.randomBytes(8).toString('hex')
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
        let encryptedText = Buffer.concat([
          cipher.update(JSON.stringify(payload)),
          cipher.final()
        ]);
        return {
          iv: iv.toString(),
          encryptedPacket: encryptedText.toString('base64')
        }
      } catch (err) {
        console.log(err)
        throw err;
      }
    },

    async decrypt(payload) {
      try {
        const key = process.env.VUE_APP_PAYSLIP_SECRET;
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, payload.iv);
        const decrypted = Buffer.concat([decipher.update(payload.encryptedPacket, 'base64'), decipher.final()]);
        return decrypted.toString();
      } catch (error) {
        // console.log(error)
      }
    },
  }
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/components/margins.scss"; //margins

  /* .mainHeading {
    font-weight:550;
    color:rgba(18, 18, 20,0.690);
    font-style:inherit
  } */
  
  .main-header{
  font-weight: bold;
  color: #777777;
  }
  .itStatementContainer{
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: flex-end;
  }
  
  .itStatementHeader{
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
    text-transform: capitalize;
  }
  
  .itStatementHeader > * {
    margin-right: 20px;
  }
  
  .searchDiv{
    width: 200px;
  }

  .downloadButton{
  height: 35px;
  width: 35px;
  cursor: pointer;
  }
  
  .itStatementHeader > svg{
    width: 30px;
    height: 30px;
    fill: #376cd3;
    cursor: pointer;
  }
  
  </style>
  